import { TYPES } from './types';
import companyService from '../services/companyService';

// Get companies with pagination and filtering
export const getCompanies = (query = {}) => async (dispatch) => {
  try {
    const response = await companyService.getCompanies(query);
    
    dispatch({
      type: TYPES.ACTION_GET_COMPANIES_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    console.error('Error getting companies:', error);
    
    dispatch({
      type: TYPES.ACTION_GET_COMPANIES_FAIL,
      payload: error.response?.data?.message || 'Failed to fetch companies'
    });
    
    throw error;
  }
};

// Get company by ID
export const getCompanyByID = (id) => async (dispatch) => {
  try {
    const response = await companyService.getCompanyByID(id);
    
    dispatch({
      type: TYPES.ACTION_GET_COMPANY_BY_ID_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    console.error('Error getting company by ID:', error);
    
    dispatch({
      type: TYPES.ACTION_GET_COMPANY_BY_ID_FAIL,
      payload: error.response?.data?.message || 'Failed to fetch company'
    });
    
    throw error;
  }
};

// Get company by company_id
export const getCompanyByCompanyID = (company_id) => async (dispatch) => {
  try {
    const response = await companyService.getCompanyByCompanyID(company_id);
    
    dispatch({
      type: TYPES.ACTION_GET_COMPANY_BY_COMPANY_ID_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    console.error('Error getting company by company_id:', error);
    
    dispatch({
      type: TYPES.ACTION_GET_COMPANY_BY_COMPANY_ID_FAIL,
      payload: error.response?.data?.message || 'Failed to fetch company'
    });
    
    throw error;
  }
};

// Create company
export const createCompany = (companyData) => async (dispatch) => {
  try {
    const response = await companyService.createCompany(companyData);
    
    dispatch({
      type: TYPES.ACTION_CREATE_COMPANY_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    console.error('Error creating company:', error);
    
    dispatch({
      type: TYPES.ACTION_CREATE_COMPANY_FAIL,
      payload: error.response?.data?.message || 'Failed to create company'
    });
    
    throw error;
  }
};

// Update company
export const updateCompany = (id, companyData) => async (dispatch) => {
  try {
    const response = await companyService.updateCompany(id, companyData);
    
    dispatch({
      type: TYPES.ACTION_UPDATE_COMPANY_SUCCESS,
      payload: { id, data: response.data }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error updating company:', error);
    
    dispatch({
      type: TYPES.ACTION_UPDATE_COMPANY_FAIL,
      payload: error.response?.data?.message || 'Failed to update company'
    });
    
    throw error;
  }
};

// Delete company
export const deleteCompany = (id) => async (dispatch) => {
  try {
    const response = await companyService.deleteCompany(id);
    
    dispatch({
      type: TYPES.ACTION_DELETE_COMPANY_SUCCESS,
      payload: { id, data: response.data }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error deleting company:', error);
    
    dispatch({
      type: TYPES.ACTION_DELETE_COMPANY_FAIL,
      payload: error.response?.data?.message || 'Failed to delete company'
    });
    
    throw error;
  }
};
